import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "routing-addresses-empty" }

import { inject } from 'vue';
import type { Translator } from 'types/injects/translator.type';
// TODO(SAAS-32515): replace with the real FAQ URL once available.
const FAQ_URL = 'https://help.sellsy.com/fr/';


export default /*@__PURE__*/_defineComponent({
  __name: 'RoutingAddressesEmptyNotDetected',
  setup(__props) {

const $t = inject('$t') as Translator;

const translations: Record<string, string> = {
    title: $t.__('overview.tabs.TabRoutingAddresses.empty_state.not_detected.title'),
    caption: $t.__('overview.tabs.TabRoutingAddresses.empty_state.not_detected.subtitle'),
    action: $t.__('overview.tabs.TabRoutingAddresses.empty_state.not_detected.action'),
};

const onLearnMore = (): void => {
    window.open(FAQ_URL, '_blank', 'noopener,noreferrer');
};

return (_ctx: any,_cache: any) => {
  const _component_CompassButton = _resolveComponent("CompassButton")!
  const _component_CompassEmptyState = _resolveComponent("CompassEmptyState")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CompassEmptyState, {
      illustrationPath: "/ressources/logged/img/illustrations/pdp/warning-company-directory-white.svg",
      title: translations.title,
      caption: translations.caption
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassButton, {
          label: translations.action,
          type: _ctx.CompassEnums.ButtonType.TERTIARY,
          onClick: onLearnMore
        }, null, 8 /* PROPS */, ["label", "type"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title", "caption"])
  ]))
}
}

})